import {useCallback, useEffect} from 'react';
import {useParams} from 'react-router';

import ChatForm from 'modules/chatForm';
import useUserMessages from './hooks';

const ChatsFormContainer = () => {
  const {chatId} = useParams();
  const {messages, isRoomLoading, refetch, fetchNextPage} =
    useUserMessages(chatId);

  const onWatchEnd = useCallback(() => {
    fetchNextPage();
  }, [fetchNextPage]);

  useEffect(() => {
    if (!chatId) return;
    refetch();

    const refetchChatInterval = setInterval(refetch, 10000);

    return () => clearInterval(refetchChatInterval);
  }, [refetch, chatId]);

  return (
    <div className="h-full">
      <ChatForm
        isScrollLoading={isRoomLoading}
        onWatchEnd={onWatchEnd}
        refresh={refetch}
        elements={messages?.pages.flatMap(x => x.results) || []}
        chatId={chatId}
      />
    </div>
  );
};

export default ChatsFormContainer;
